export default "__VITE_ASSET__123b3697__"